import React from 'react'

import { InputButtonGroupProps } from './InputButtonGroup.types'

const InputButtonGroup: React.FC<InputButtonGroupProps> = ({ style = {}, children }) => {
    return (
        <div style={style} data-testid='InputButtonGroup' className='r-inputbuttongroup-container'>
            {children}
        </div>
    )
}

export default InputButtonGroup
